import { VA_FORM_IDS } from '@department-of-veterans-affairs/platform-forms/constants';
import { trackAction } from '../../../../shared/utils/tracking/datadogRumTracking';
import { isExpired } from '../../index';

const categorizeDaysRemaining = days => {
  if (days <= 7) return '0-7-days';
  if (days <= 30) return '8-30-days';
  if (days <= 60) return '31-60-days';
  if (days <= 90) return '61-90-days';
  if (days <= 120) return '91-120-days';
  if (days <= 180) return '121-180-days';
  if (days <= 210) return '181-210-days';
  return '211-plus-days';
};

const hasInProgressForm = (savedForms = []) =>
  savedForms.some(
    savedForm =>
      savedForm.form === VA_FORM_IDS.FORM_21_526EZ &&
      !isExpired(savedForm.metadata),
  );

/**
 * Track when a user first views the wizard and has an in-progress form
 *
 * @param {Object} params - Tracking parameters
 * @param {Array} params.savedForms - Array of saved forms from user profile
 */
export const trackWizardViewedWithInProgressForm = ({ savedForms }) => {
  if (!hasInProgressForm(savedForms)) return;

  trackAction('21-526EZ_wizard_viewedWithInProgressForm', {
    formId: VA_FORM_IDS.FORM_21_526EZ,
  });
};

export const trackWizardStepView = ({ stepName }) => {
  trackAction('21-526EZ_wizard_stepViewed', {
    formId: VA_FORM_IDS.FORM_21_526EZ,
    stepName,
  });
};

export const trackWizardActiveDutySelection = ({ isActiveDuty }) => {
  trackAction('21-526EZ_wizard_activeDutySelected', {
    formId: VA_FORM_IDS.FORM_21_526EZ,
    pageName: 'start',
    fieldName: 'active-duty',
    fieldValue: isActiveDuty ? 'yes' : 'no',
  });
};

export const trackWizardSeparationDateEntered = ({ daysUntilSeparation }) => {
  trackAction('21-526EZ_wizard_separationDateEntered', {
    formId: VA_FORM_IDS.FORM_21_526EZ,
    pageName: 'bdd',
    fieldName: 'separation-date',
    daysRemainingCategory: categorizeDaysRemaining(daysUntilSeparation),
  });
};

export const trackWizardClaimTypeSelection = claimType => {
  trackAction('21-526EZ_wizard_claimTypeSelected', {
    formId: VA_FORM_IDS.FORM_21_526EZ,
    pageName: 'appeals',
    fieldName: 'claim-type',
    fieldValue: claimType,
  });
};

export const trackWizardFileClaimLinkClick = ({ linkLabel, pageName }) => {
  trackAction('21-526EZ_wizard_fileClaimLinkClicked', {
    formId: VA_FORM_IDS.FORM_21_526EZ,
    pageName,
    linkLabel,
  });
};

export const trackWizardExternalLinkClick = ({ linkLabel, pageName }) => {
  trackAction('21-526EZ_wizard_externalLinkClicked', {
    formId: VA_FORM_IDS.FORM_21_526EZ,
    pageName,
    linkLabel,
  });
};

export const trackWizardBddEligibilityDisplayed = ({
  daysRemaining,
  isLastDay,
}) => {
  trackAction('21-526EZ_wizard_BDDEligibilityDisplayed', {
    formId: VA_FORM_IDS.FORM_21_526EZ,
    daysRemainingCategory: categorizeDaysRemaining(daysRemaining),
    isLastDay,
    eligibilityType: 'bdd',
  });
};

export const trackWizardUnableToFileBddDisplayed = ({
  reason,
  daysRemaining,
}) => {
  trackAction('21-526EZ_wizard_unableToFileBDDDisplayed', {
    formId: VA_FORM_IDS.FORM_21_526EZ,
    reason,
    daysRemainingCategory: categorizeDaysRemaining(daysRemaining),
    eligibilityType: 'not-eligible',
  });
};

export const trackWizardOptOut = () => {
  trackAction('21-526EZ_wizard_userOptedOut', {
    formId: VA_FORM_IDS.FORM_21_526EZ,
  });
};

export const trackWizardValidationError = ({
  pageName,
  fieldName,
  errorMessage,
}) => {
  trackAction('21-526EZ_wizard_validationError', {
    formId: VA_FORM_IDS.FORM_21_526EZ,
    pageName,
    fieldName,
    errorType: 'validation',
    errorMessage,
  });
};
